module.exports = "/images/general@3x.png?1a8b4b88f1947eabe13763c19753629a";